export default "__VITE_ASSET__DLCcs8Sh__"